package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_cash_register


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateCashRegister(
    @SerialName("id")
    val id: String?,
//    @SerialName("parameters")
//    val parameters: String?=null,//TODO(This String type is wrong ,
    @SerialName("__typename")
    val typename: String?
)